import axios from "axios";
import { headerConfig } from "../utility/RequestHeaderConfig";
import { BASE_API_URL, DOMAIN_URL } from "../utility/URL";



const programmeGroupList = async () => {
    const response = await axios
        .post(BASE_API_URL + "programme/group", {}, headerConfig);
    return response;
};


const programmeList = async () => {
    const response = await axios
        .post(BASE_API_URL + "programme/list", {}, headerConfig);
    return response;
};

const programmeByCode = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/code", data, headerConfig);
    return response;
};

const checkMemberEnrolement = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/check-member-enrolement", data, headerConfig);
    return response;
};

const tapMemberDetail = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/tap-member-details", data, headerConfig);
    return response;
};


const tapMemberEnrolement = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/tap-member-enrolement", data, headerConfig);
    return response;
};

const memberInfoByID = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/member-info", data, headerConfig);
    return response;
};

const monthList = async () => {
    const response = await axios
        .post(BASE_API_URL + "programme/monthlist", {}, headerConfig);
    return response;
};

const yearList = async () => {
    const response = await axios
        .post(BASE_API_URL + "programme/yearlist", {}, headerConfig);
    return response;
};


const monthlyPaidJcp = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/monthly-paid-jcp", data, headerConfig);
    return response;
};

const monthlyUnPaidJcp = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/monthly-unpaid-jcp", data, headerConfig);
    return response;
};

const monthlyPaidUnPaidJcp = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/monthly-paid-unpaid-jcp", data, headerConfig);
    return response;
};


const paymentMonthByReceipt = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/payment-months-receipt", data, headerConfig);
    return response;
};


const otherItemsReceiptList = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/others-receipt-jcp", data, headerConfig);
    return response;
};


const memberLastMonthPayment = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/member-last-month-payment", data, headerConfig);
    return response;
};


const tapMembershipFee = async () => {
    const response = await axios
        .post(BASE_API_URL + "programme/tap-rate", {}, headerConfig);
    return response;
};


const tapMemberList = async () => {
    const response = await axios
        .post(BASE_API_URL + "programme/tap-memberList", {}, headerConfig);
    return response;
};


const tapMemberListAll = async () => {
    const response = await axios
        .post(BASE_API_URL + "programme/tap-memberList-all", {}, headerConfig);
    return response;
};

const tapBookingList = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/tap-booking-list", data, headerConfig);
    return response;
};

const tapDailyBookingList = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/tap-daily-booking", data, headerConfig);
    return response;
};


const tapBookingDetailList = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/tap-booking-details", data, headerConfig);
    return response;
};


const accountReportLink = async (data) => {
    const response = await axios
        //.post("http://btaportal.in/custom/report/trialbalance/printpdf", data);
        .post(DOMAIN_URL + "custom/report/admin/generateLink", data, headerConfig);
    return response;
};

const memberListPromoted = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/member-list-promoted", data, headerConfig);
    return response;
};

const memberListWithOpeningBalance = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/member-list-opening-balance", data, headerConfig);
    return response;
};

const coachListWithRatioRate = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/coach-list-ratio-rate", data, headerConfig);
    return response;
};

const coachListWithRatioRateWithType = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/coach-list-ratio-rate-type", data, headerConfig);
    return response;
};


const memberAdjustmentList = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/tap-book-cancel-bta", data, headerConfig);
    return response;
};


const programmeListForScheduleReport = async () => {
    const response = await axios
        .post(BASE_API_URL + "programme/programme-list-timereport", {}, headerConfig);
    return response;
};


const timeSlotByProgramme = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/time-slot-programme", data, headerConfig);
    return response;
};

const memberTimeSlotReport = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/member-time-slot-report", data, headerConfig);
    return response;
};

const openingBalanceAction = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/member-opening-balance", data, headerConfig);
    return response;
};

const updateMemberTimeSlotDetails = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/update-member-time-slot-details", data, headerConfig);
    return response;
};


const allReceipt = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/all-receipt", data, headerConfig);
    return response;
};

const allPayment = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/get-payment-by-mode", data, headerConfig);
    return response;
};

const tournamentReceiptList = async () => {
    const response = await axios
        .post(BASE_API_URL + "tournament/receipt-list", {}, headerConfig);
    return response;
};


const tournamentList = async () => {
    const response = await axios
        .post(BASE_API_URL + "tournament/list", {}, headerConfig);
    return response;
};


const tournamentAction = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "tournament/action", data, headerConfig);
    return response;
};

const deleteReceipt = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "delete/receipt", data, headerConfig);
    return response;
};

// TRANSFER PROGRAMME //

const transferProgramme = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/member-data-programme", data, headerConfig);
    return response;
    console.log("responseTransfer", response)
};

// SAVE TRANSFER PROGRAMME //

const saveTransferProgramme = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programtransfer/JcpToHpTransfer", data, headerConfig);
    return response;
    console.log("responseTransfer", response)
};

//  Inactive Member AllReciept page  //

const inActiveMemberAllReciept = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/inactive-invoice", data, headerConfig);
    return response;
    console.log("responseTransfer", response)
};

const getWaiveList = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "search-waive-list/get-waive-list", data, headerConfig);
    return response;
    console.log("waiveList", response)
};


const getDailyCollection = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/get-program-component-by-progid", data, headerConfig);
    return response;
    console.log("dailyCollection", response)
};

const getLastPaidMonth = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programtransfer/last-paid-month", data, headerConfig);
    return response;

};

const getProgrammeTransferList = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programtransfer/promoted-active-list", data, headerConfig);
    return response;
}

const editMemberNameInBooking = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/edit-member-name", data, headerConfig);
    return response;
};

const deleteBookingTransaction = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/delete-booking", data, headerConfig);
    return response;
}


const ProgrammeService = {
    programmeGroupList,
    programmeList,
    programmeByCode,
    checkMemberEnrolement,
    memberInfoByID,
    monthList,
    yearList,
    monthlyPaidJcp,
    monthlyUnPaidJcp,
    monthlyPaidUnPaidJcp,
    paymentMonthByReceipt,
    otherItemsReceiptList,
    memberLastMonthPayment,
    accountReportLink,
    tapMembershipFee,
    tapMemberList,
    tapMemberListAll,
    tapMemberEnrolement,
    tapBookingList,
    tapBookingDetailList,
    memberListPromoted,
    tapMemberDetail,
    coachListWithRatioRate,
    coachListWithRatioRateWithType,
    memberAdjustmentList,
    tapDailyBookingList,
    programmeListForScheduleReport,
    timeSlotByProgramme,
    memberTimeSlotReport,
    updateMemberTimeSlotDetails,
    allReceipt,
    allPayment,
    memberListWithOpeningBalance,
    openingBalanceAction,
    tournamentList,
    tournamentAction,
    tournamentReceiptList,
    deleteReceipt,
    transferProgramme,
    saveTransferProgramme,
    inActiveMemberAllReciept,
    getWaiveList,
    getDailyCollection,
    getLastPaidMonth,
    getProgrammeTransferList,
    editMemberNameInBooking,
    deleteBookingTransaction
};

export default ProgrammeService;